import { render, staticRenderFns } from "./ItemsOrder.vue?vue&type=template&id=03f15690&"
import script from "./ItemsOrder.vue?vue&type=script&lang=js&"
export * from "./ItemsOrder.vue?vue&type=script&lang=js&"
import style0 from "./ItemsOrder.vue?vue&type=style&index=0&id=03f15690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports